export default "__VITE_ASSET__DK_XcAMR__"